export default __webpack_public_path__ + "static/media/capella.aefb4136.png";